export default {
	title: "Líneas Espirituales",
	description: "Gestión de líneas espirituales",
	confirmDeleteMessage: "¿Está seguro de que desea eliminar la línea espiritual \"{name}\"? Esta acción no se puede deshacer.",
	create: "Nueva Línea Espiritual",
	edit: "Editar Línea Espiritual",
	form: {
		description: "Descripción",
		icon: "Icono",
		name: "Nombre de la Línea",
		primaryColor: "Color Principal",
	},
	delete: {
		hasLinksWarning: "Esta línea tiene {guides} guía(s) y {ritualTypes} tipo(s) de ritual vinculado(s). Serán movidos a la línea seleccionada antes de eliminar.",
		reassignLabel: "Mover guías y tipos de ritual a",
		reassignAndDelete: "Mover y eliminar",
		noTargetLines: "Ninguna otra línea disponible para la reasignación",
	},
	messages: {
		createError: "Error al crear línea espiritual",
		createSuccess: "Línea espiritual creada con éxito",
		deleteError: "Error al eliminar línea espiritual",
		deleteSuccess: "Línea espiritual eliminada con éxito",
		reassignDeleteSuccess: "Elementos reasignados y línea espiritual eliminada con éxito",
		loadError: "Error al cargar líneas espirituales",
		updateError: "Error al actualizar línea espiritual",
		updateSuccess: "Línea espiritual actualizada con éxito",
	},
	name: "Nombre",
	noData: "Ninguna línea espiritual encontrada",
	noDataSubtext: "Comience creando su primera línea espiritual",
	primaryColor: "Color Principal",
	searchNoResults: "Ninguna línea encontrada para '{search}'",
	searchPlaceholder: "Buscar líneas espirituales...",
	stats: {
		total: "Líneas",
	},
	validation: {
		descriptionMaxLength: "La descripción debe tener máximo 500 caracteres",
		nameMaxLength: "El nombre debe tener máximo 100 caracteres",
		nameRequired: "El nombre es obligatorio",
	},
};
